import {Injectable, inject} from '@angular/core';
import {Observable, forkJoin, of} from 'rxjs';
import {map, first, catchError} from 'rxjs/operators';
import {Account} from '../../../account/domain/model/account.model';
import {PaymentContext} from '../../domain/value-objects/payment-context.model';
import {DeviceService} from '../../../device/device.service';
import {
  OrganizationRepositoryAdapter
} from '../../../organization/infrastructure/adapters/organization-repository.adapter';
import {AuditService} from '../../../audit/audit.service';
import {TicketEventService} from '../../../ticket-events/ticket-event.service';
import {AccountStorePort} from 'src/app/core/entities/account/domain/ports/account-store.port';
import {ACCOUNT_STORE} from 'src/app/core/entities/account/domain/tokens/account-store.token';

import {SERVICE_STATE_SERVICE} from '@features/service/domain/tokens/service-state.token';

@Injectable({providedIn: 'root'})
export class PaymentContextService {
  private readonly auditService = inject(AuditService);
  private readonly deviceService = inject(DeviceService);
  private readonly ticketEventService = inject(TicketEventService);
  private readonly organizationService = inject(OrganizationRepositoryAdapter);
  private readonly accountStoreService = inject<AccountStorePort>(ACCOUNT_STORE);

  private readonly serviceStateService = inject(SERVICE_STATE_SERVICE);

  private get getCurrentAccount(): Account | undefined {
    return this.accountStoreService.getSelectedAccount();
  }

  getContext(): Observable<PaymentContext> {
    return forkJoin({
      account: of(this.getCurrentAccount),
      device: of(this.deviceService.device!),
      drawer: of(this.serviceStateService.getCurrentDrawer()),
      worker: of(this.serviceStateService.getCurrentWorker()),
      audit: this.auditService.getCurrentAuditAccount(),
      organization: this.organizationService.getCurrentOrganization(),
      ticketEvent: this.ticketEventService.getCurrentTicketEvent(),
    }).pipe(
      first(),
      map(data => new PaymentContext(
        data.drawer!,
        data.worker!,
        data.organization!,
        data.account!,
        data.audit!,
        data.ticketEvent!,
        data.device
      )),
      catchError(() => {
        throw new Error('Failed to gather payment context data');
      })
    );
  }

}
